/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../js/global" ;
import * as helper from "../../js/helper";
import full_loading from "../components/full-loading.vue";
import VueSelect from '../../js/vue-select.js';
import Datepicker from '../../js/vuejs-datepicker.min.js';
const __vue_script__ = {
    components: {
        full_loading: full_loading,
        vue_select: VueSelect,
        Datepicker: Datepicker,
    },
    name: 'unpublish_modal',
    props: {
    },
    data() {
        return {
            global,
            helper,
            is_loading: false,
            error: false,
            exceptions: [],
            property: null,
            main_building: false,
            floor_index: "",
            selected_child:null,
            property_name:"",
            ad_type_color: '#0000ff',
            property_type_icon: '#0000ff',
            tanent: "",
            full_name: null,
            deal_price: null,
            deal_rent_type: "Annually",
            step: 0,
            reason:"",
            starting_at:new Date(),
            contract_multiplier:1,
            ending_at:null,
            disabled_dates:{
                to: new Date(new Date().setDate(new Date().getDate()-1)),
            },
            attachment:null,
            imageUrl:null,
            filename:null,
            filetype:null,
        }
    },
    mounted() {
        var exampleModal = document.getElementById('unpublishModal');
        exampleModal.addEventListener('show.bs.modal', this.load_property_data);
        this.calculate_ending_at();
    },
    methods: {
        resetForm: function () {
            // this.main_building = true;
            this.floor_index = "";
            this.tanent = ""; 
            this.full_name = null;
            this.attachment = null;
            this.step = 0;
            this.reason = "";
            this.selected_child = null;
            this.resetErrors();
        },
        resetErrors: function () {
            this.error = false;
            this.exceptions = [];
        },
        load_property_data: async function (event) {
            this.loading = true;
            this.property = null;
            this.resetForm();
            this.main_building = false;
            // Button that triggered the modal
            var button = event.relatedTarget;
            // Extract info from data-bs-* attributes
            this.property_name = button.getAttribute('data-bs-property-name');
            this.form_sent = true;
            let params = {
                property_name: this.property_name
            };
            try {
                let res = await $.ajax({
                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                    url: "/api/method/maalek.api.get_property_with_children",
                    type: "GET",
                    data: params //for GET request
                    // data: JSON.stringify(params) //for POST request
                });
                this.property = res.message;
                // if (this.property.floors.length > 0)
                //     this.main_building = false;
                this.loading = false
                this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];
                this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];
                if(this.property.floors.length > 0){
                    this.main_building = false;
                }else{
                    this.main_building = true;
                }
                this.$forceUpdate();
            } catch (e) {
                console.log("failed");
                console.log(e);
                this.exceptions = helper.showException(e);
            }

            this.loading = false
        },
        getFullname: async function () {
            this.resetErrors();
            this.full_name = null;
            let params = {
                user: this.tanent
            };
            try {
                let res = await $.ajax({
                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                    url: "/api/method/maalek.api.get_fullname",
                    type: "GET",
                    data: params //for GET request
                    // data: JSON.stringify(params) //for POST request
                });
                this.loading = false;
                this.full_name = res.message;
                this.$forceUpdate();
            } catch (e) {
                console.log(e);
                this.error = true;
                this.exceptions = helper.showException(e);
            }
            this.loading = false;
        },
        askLockProperty(){
            if(this.loading || !frappe.session_user || frappe.session_user == "Guest")
                return;
            bootbox.confirm({
                message: `<div class="alert alert-danger" role="alert">
                        <b>`+helper.t("Warning: you cannot undo this action.")+`</b><br>
                        `+helper.t("Do you want to lock this property permanently?")+`
                </div>`,
                buttons: {
                    confirm: {
                        label: helper.t("Yes"),
                        className: 'btn-success'
                    },
                    cancel: {
                        label: helper.t("No"),
                        className: 'btn-danger'
                    }
                },
                backdrop: true,
                callback: (results) => results?this.unpublish():console.log("cancel"),
            });
        },
        unpublish: async function (){
            this.resetErrors();
            this.form_sent = true;
            let params = {
                property_name: this.property.name,
                reason: this.reason
            };
            global.emitter.emit("show-full-loading");
            try {
                let res = await $.ajax({
                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                    url: "/api/method/maalek.api.unpublish",
                    type: "POST",
                    // data: params //for GET request
                    data: JSON.stringify(params) //for POST request
                });
                this.loading = false
                global.emitter.emit("refresh-tanent");
                helper.showSuccess(this.reason=="Lock"?"Property locked permanenetly":"Property unpublished",()=>{
                    location.reload();
                });
            } catch (e) {
                this.error = true;
                this.exceptions = helper.showException(e);
            }
            global.emitter.emit("hide-full-loading");
            this.loading = false
        },
        sellProperty: async function (){
            this.resetErrors();
            this.form_sent = true;
            let params = {
                property_name: this.main_building ? this.property.name : this.selected_child.name,
                reason: this.reason,
                tanent: this.tanent,
                tanent_full_name: this.full_name,
                deal_price: this.deal_price,
            };
            try {
                let res = await $.ajax({
                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                    url: "/api/method/maalek.api.sell_property",
                    type: "POST",
                    // data: params //for GET request
                    data: JSON.stringify(params) //for POST request
                });
                this.loading = false
                this.error = false;
                global.emitter.emit("refresh-tanent");
                helper.showSuccess("Property sold",()=>{
                    location.reload();
                });
            } catch (e) {
                this.error = true;
                this.exceptions = helper.showException(e);
            }
            this.loading = false
        },
        rentProperty: async function (){
            this.resetErrors();
            this.form_sent = true;
            let params = {
                property_name: this.main_building ? this.property.name : this.selected_child.name,
                reason: this.reason,
                deal_price: this.deal_price,
                deal_rent_type: this.deal_rent_type,
                tanent: this.tanent,
                tanent_full_name: this.full_name,
                starting_at:this.starting_at,
                ending_at:this.ending_at,
                attachment:this.attachment
            };
            try {
                let res = await $.ajax({
                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                    url: "/api/method/maalek.api.rent_property",
                    type: "POST",
                    // data: params //for GET request
                    data: JSON.stringify(params) //for POST request
                });
                this.loading = false
                this.error = false;
                global.emitter.emit("refresh-tanent");
                helper.showSuccess("Property rented",()=>{
                    location.reload();
                });
            } catch (e) {
                this.error = true;
                this.exceptions = helper.showException(e);
            }
            this.loading = false
        },
        calculate_ending_at: async function (val) {
            var temp_date = new Date(this.starting_at);
            if(val != undefined && val instanceof Date)
                temp_date = new Date(val);
            if(this.deal_rent_type == "Monthly"){
                this.ending_at =  new Date(temp_date.setMonth(temp_date.getMonth() + parseInt(this.contract_multiplier)));
            }else if(this.deal_rent_type == "Half Yearly"){
                this.ending_at =  new Date(temp_date.setMonth(temp_date.getMonth() + (6 * parseInt(this.contract_multiplier))));
            }else{
                this.ending_at =  new Date(temp_date.setFullYear(temp_date.getFullYear() + parseInt(this.contract_multiplier)));
            }
        },
        onPickFile () {
            this.$refs.fileInput.click()
        },
        onFilePicked (event) {
            const files = event.target.files
            if (files && files[0]) {
                this.attachment = {};
                this.attachment["file"] = files[0].name
                this.attachment["type"] = files[0].type
                const fileReader = new FileReader()
                fileReader.readAsDataURL(files[0])
                let reader = new FileReader;
                reader.onload = e => {
                    this.attachment["data"] = e.target.result;
                }
                reader.readAsDataURL(files[0]);
                this.$forceUpdate();
            }
        }
    },
    computed: {
        calculate_rent(){
            if(this.deal_rent_type == "Monthly"){
                return this.deal_price * 12;
            }else if(this.deal_rent_type == "Half Yearly"){
                return this.deal_price * 2;
            }else{
                return this.deal_price;
            }
        }
    }
}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "unpublishModal",
        "data-bs-backdrop": "static",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-centered modal-dialog-scrollable"
        },
        [
          _vm.property == null
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [_vm._v(_vm._s(_vm.helper.t("Loading... Please wait.")))]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.property != null
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [
                      _c("img", {
                        staticClass: "icon",
                        attrs: { src: _vm.property_type_icon }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.helper.t("Unpublish"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.property.ad_type == "Sale"
                  ? _c("div", { staticClass: "modal-body" }, [
                      _vm.step == 0
                        ? _c("div", [
                            _vm.property.floors.length > 0
                              ? _c("div", [
                                  _c("div", { staticClass: "row" }, [
                                    _c("h5", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.helper.t("Select sub property")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-6" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.floor_index,
                                                expression: "floor_index"
                                              }
                                            ],
                                            staticClass:
                                              "form-select form-control border-radius",
                                            attrs: {
                                              "aria-label":
                                                "Default select example",
                                              disabled: _vm.main_building
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.floor_index = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  disabled: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.helper.t("Select Floor")
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.property.floors,
                                              function(floor) {
                                                return _c(
                                                  "option",
                                                  {
                                                    domProps: {
                                                      value: floor.floor_num
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          floor.floor_num == 0
                                                            ? "Ground Floor"
                                                            : "Floor " +
                                                                floor.floor_num
                                                        )
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.floor_index !== ""
                                      ? _c("div", { staticClass: "col-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "form-check" },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.selected_child,
                                                      expression:
                                                        "selected_child"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-select form-control border-radius",
                                                  attrs: {
                                                    "aria-label":
                                                      "Default select example",
                                                    disabled: _vm.main_building
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.selected_child = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        value: "",
                                                        disabled: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.helper.t(
                                                            "Select Sub Property"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.property.floors[
                                                      _vm.floor_index
                                                    ].children,
                                                    function(child) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              child.locked == 1
                                                          },
                                                          domProps: {
                                                            value: child
                                                          }
                                                        },
                                                        [
                                                          child.locked
                                                            ? [
                                                                _c("b", [
                                                                  _vm._v("SOLD")
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      child.title
                                                                    ) +
                                                                    "\n                                            "
                                                                )
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      child.title
                                                                    ) +
                                                                    "\n                                            "
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.property.floors.length > 0
                              ? _c("div", { staticClass: "row my-3" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-check",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.main_building = !_vm.main_building
                                          }
                                        }
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: "flexCheckDefault"
                                          },
                                          domProps: {
                                            checked: _vm.main_building
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "form-check-label" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Unpublish The Main Building"
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.main_building ||
                            _vm.property.floors.length == 0 ||
                            _vm.selected_child != null
                              ? _c("div", [
                                  !_vm.main_building ||
                                  _vm.property.floors.length == 0
                                    ? _c("div", { staticClass: "row pt-2" }, [
                                        _c("h5", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.helper.t(
                                                "Did you SOLD through Maalek.net?"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-12" }, [
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "list-group list-group-flush"
                                            },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "list-group-item show-hand",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.reason = "Inside"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.reason == "Inside"
                                                    ? _c("i", {
                                                        staticClass:
                                                          "ri-checkbox-circle-fill"
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "ri-checkbox-blank-circle-line"
                                                      }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Sold through Maalek.net (Ad will be permanently locked)"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "list-group-item show-hand",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.reason = "Outside"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.reason == "Outside"
                                                    ? _c("i", {
                                                        staticClass:
                                                          "ri-checkbox-circle-fill"
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "ri-checkbox-blank-circle-line"
                                                      }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Sold through other source (Ad will be permanently locked)"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.property.floors.length == 0
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "list-group-item show-hand",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.reason =
                                                            "Unpublish"
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.reason == "Unpublish"
                                                        ? _c("i", {
                                                            staticClass:
                                                              "ri-checkbox-circle-fill"
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "ri-checkbox-blank-circle-line"
                                                          }),
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.helper.t(
                                                              "Unpublish Only (Ad can be republished later)"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.property.floors.length == 0
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "list-group-item show-hand mb-3",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.reason = "Lock"
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.reason == "Lock"
                                                        ? _c("i", {
                                                            staticClass:
                                                              "ri-checkbox-circle-fill"
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "ri-checkbox-blank-circle-line"
                                                          }),
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.helper.t(
                                                              "Close this advertisement (Ad will be permanently locked)"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.reason != "Unpublish" &&
                                          _vm.reason != ""
                                            ? _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "text-danger ms-4"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.t(
                                                        "Note: Locked ads cannot be republished or edited"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.main_building || _vm.reason != ""
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-end mt-2"
                                        },
                                        [
                                          (_vm.property.floors.length == 0 ||
                                            !_vm.main_building) &&
                                          (_vm.reason == "Inside" ||
                                            _vm.reason == "Outside")
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-primary",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.deal_rent_type =
                                                        _vm.property.floors
                                                          .length == 0
                                                          ? _vm.property
                                                              .rent_type
                                                          : _vm.selected_child
                                                              .rent_type
                                                      _vm.deal_price =
                                                        _vm.property.floors
                                                          .length == 0
                                                          ? _vm.property
                                                              .total_price
                                                          : _vm.selected_child
                                                              .total_price
                                                      _vm.step = 1
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Next Step"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : (_vm.main_building &&
                                                _vm.property.floors.length >
                                                  0) ||
                                              _vm.reason != ""
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-primary",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.reason == "Lock"
                                                        ? _vm.askLockProperty()
                                                        : _vm.unpublish()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Unpublish"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.step == 1
                        ? _c("div", [
                            _c("div", { staticClass: "row" }, [
                              _c("h5", [
                                _vm._v(
                                  _vm._s(
                                    _vm.helper.t("Give further information")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.helper.t("Sold for how much?"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.deal_price,
                                        expression: "deal_price"
                                      }
                                    ],
                                    staticClass: "form-control border-radius",
                                    attrs: { type: "number" },
                                    domProps: { value: _vm.deal_price },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.deal_price = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.t(
                                          "Buyer's Mobile No. (optional)"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.tanent,
                                        expression: "tanent"
                                      }
                                    ],
                                    staticClass: "form-control border-radius",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.tanent },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.tanent = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.t(
                                          "Buyer's Full Name (optional)"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.full_name,
                                        expression: "full_name"
                                      }
                                    ],
                                    staticClass: "form-control border-radius",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.full_name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.full_name = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row text-start mt-2" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-light",
                                        on: {
                                          click: function($event) {
                                            return _vm.resetForm()
                                          }
                                        }
                                      },
                                      [
                                        _vm.full_name == null
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(_vm.helper.t("Cancel"))
                                              )
                                            ])
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Cancel / Change"
                                                  )
                                                )
                                              )
                                            ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.deal_price > 0 &&
                                    (_vm.reason == "Outside" ||
                                      _vm.reason == "Inside")
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "btn btn-primary",
                                            on: {
                                              click: function($event) {
                                                return _vm.sellProperty()
                                              }
                                            }
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Save and Unpublish"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.property.ad_type == "Rent"
                  ? _c("div", { staticClass: "modal-body" }, [
                      _vm.step == 0
                        ? _c("div", [
                            _vm.property.floors.length > 0
                              ? _c("div", [
                                  _c("div", { staticClass: "row" }, [
                                    _c("h5", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.helper.t("Select sub property")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-6" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.floor_index,
                                                expression: "floor_index"
                                              }
                                            ],
                                            staticClass:
                                              "form-select form-control border-radius",
                                            attrs: {
                                              disabled: _vm.main_building,
                                              "aria-label":
                                                "Default select example"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.floor_index = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  disabled: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.helper.t("Select Floor")
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.property.floors,
                                              function(floor) {
                                                return _c(
                                                  "option",
                                                  {
                                                    domProps: {
                                                      value: floor.floor_num
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          floor.floor_num == 0
                                                            ? "Ground Floor"
                                                            : "Floor " +
                                                                floor.floor_num
                                                        )
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.floor_index !== ""
                                      ? _c("div", { staticClass: "col-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "form-check" },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.selected_child,
                                                      expression:
                                                        "selected_child"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-select form-control border-radius",
                                                  attrs: {
                                                    disabled: _vm.main_building,
                                                    "aria-label":
                                                      "Default select example"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.selected_child = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        value: "",
                                                        disabled: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.helper.t(
                                                            "Select Sub Property"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.property.floors[
                                                      _vm.floor_index
                                                    ].children,
                                                    function(child) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              child.locked == 1
                                                          },
                                                          domProps: {
                                                            value: child
                                                          }
                                                        },
                                                        [
                                                          child.occupent
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      child.title
                                                                    )
                                                                ),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      child.occupent
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          child.locked
                                                            ? [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.helper.t(
                                                                        "Locked"
                                                                      )
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(
                                                                  " - " +
                                                                    _vm._s(
                                                                      child.title
                                                                    ) +
                                                                    "\n                                            "
                                                                )
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      child.title
                                                                    ) +
                                                                    "\n                                            "
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.property.floors.length > 0
                              ? _c("div", { staticClass: "row my-3" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-check",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.main_building = !_vm.main_building
                                          }
                                        }
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "form-check-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: "flexCheckDefault"
                                          },
                                          domProps: {
                                            checked: _vm.main_building
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "form-check-label" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Unpublish The Main Building"
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.main_building ||
                            _vm.property.floors.length == 0 ||
                            _vm.selected_child != null
                              ? _c("div", [
                                  !_vm.main_building ||
                                  _vm.property.floors.length == 0
                                    ? _c("div", { staticClass: "row pt-2" }, [
                                        _c("h5", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.helper.t(
                                                "Did you rented through Maalek.net?"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-12" }, [
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "list-group list-group-flush"
                                            },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "list-group-item show-hand",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.reason = "Inside"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.reason == "Inside"
                                                    ? _c("i", {
                                                        staticClass:
                                                          "ri-checkbox-circle-fill"
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "ri-checkbox-blank-circle-line"
                                                      }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Yes rented using Maalek.net (unpublish & lock)"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "list-group-item show-hand",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.reason = "Outside"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.reason == "Outside"
                                                    ? _c("i", {
                                                        staticClass:
                                                          "ri-checkbox-circle-fill"
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "ri-checkbox-blank-circle-line"
                                                      }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Yes rented, but not using Maalek.net (unpublish & lock)"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.property.floors.length == 0
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "list-group-item show-hand",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.reason =
                                                            "Unpublish"
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.reason == "Unpublish"
                                                        ? _c("i", {
                                                            staticClass:
                                                              "ri-checkbox-circle-fill"
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "ri-checkbox-blank-circle-line"
                                                          }),
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.helper.t(
                                                              "Not rented yet. (unpublish)"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.property.floors.length == 0
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "list-group-item show-hand",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.reason = "Lock"
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.reason == "Lock"
                                                        ? _c("i", {
                                                            staticClass:
                                                              "ri-checkbox-circle-fill"
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "ri-checkbox-blank-circle-line"
                                                          }),
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.helper.t(
                                                              "Not for rent now (unpublish & lock)"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.main_building || _vm.reason != ""
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-end mt-2"
                                        },
                                        [
                                          (_vm.property.floors.length == 0 ||
                                            !_vm.main_building) &&
                                          (_vm.reason == "Inside" ||
                                            _vm.reason == "Outside")
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-primary",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.deal_rent_type =
                                                        _vm.property.floors
                                                          .length == 0
                                                          ? _vm.property
                                                              .rent_type
                                                          : _vm.selected_child
                                                              .rent_type
                                                      _vm.deal_price =
                                                        _vm.property.floors
                                                          .length == 0
                                                          ? _vm.property
                                                              .total_price
                                                          : _vm.selected_child
                                                              .total_price
                                                      _vm.step = 1
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Next Step"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : (_vm.main_building &&
                                                _vm.property.floors.length >
                                                  0) ||
                                              _vm.reason != ""
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-primary",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.reason == "Lock"
                                                        ? _vm.askLockProperty()
                                                        : _vm.unpublish()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          "Unpublish"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.step == 1
                        ? _c("div", [
                            _c("div", { staticClass: "row" }, [
                              _c("h5", [
                                _vm._v(
                                  _vm._s(
                                    _vm.helper.t("Give further information")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.helper.t("Yearly Rent")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.deal_price,
                                        expression: "deal_price"
                                      }
                                    ],
                                    staticClass: "form-control border-radius",
                                    attrs: { type: "number" },
                                    domProps: { value: _vm.deal_price },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.deal_price = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.helper.t("Starting At"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("Datepicker", {
                                      attrs: {
                                        dir: "ltr",
                                        "input-class":
                                          "form-control border-radius text-start"
                                      },
                                      on: { selected: _vm.calculate_ending_at },
                                      model: {
                                        value: _vm.starting_at,
                                        callback: function($$v) {
                                          _vm.starting_at = $$v
                                        },
                                        expression: "starting_at"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.t("Contract Multiplier")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.contract_multiplier,
                                        expression: "contract_multiplier"
                                      }
                                    ],
                                    staticClass: "form-control border-radius",
                                    attrs: { type: "number" },
                                    domProps: {
                                      value: _vm.contract_multiplier
                                    },
                                    on: {
                                      change: _vm.calculate_ending_at,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.contract_multiplier =
                                          $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.ending_at != null
                                    ? _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.helper.t("Contract Ending At:")
                                          ) + " "
                                        ),
                                        _c("span", { attrs: { dir: "ltr" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.ending_at.getDate() +
                                                "-" +
                                                _vm.global.global_params.months[
                                                  _vm.ending_at.getMonth()
                                                ] +
                                                "-" +
                                                _vm.ending_at.getFullYear()
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-6" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.t(
                                          "Renter's Mobile No. (optional)"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.tanent,
                                        expression: "tanent"
                                      }
                                    ],
                                    staticClass: "form-control border-radius",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.tanent },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.tanent = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-6" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.t(
                                          "Renter's Full Name (optional)"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.full_name,
                                        expression: "full_name"
                                      }
                                    ],
                                    staticClass: "form-control border-radius",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.full_name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.full_name = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group text-center" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn border-btn mt-2",
                                        on: { click: _vm.onPickFile }
                                      },
                                      [
                                        _vm.attachment == null
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Contract File (Optional)"
                                                  )
                                                )
                                              )
                                            ])
                                          : _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Contract File: {0}",
                                                    [
                                                      _vm.attachment[
                                                        "file"
                                                      ].substring(0, 24) +
                                                        "..." +
                                                        _vm.attachment[
                                                          "file"
                                                        ].substring(
                                                          _vm.attachment["file"]
                                                            .length - 4
                                                        )
                                                    ]
                                                  )
                                                )
                                              )
                                            ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "fileInput",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        type: "file",
                                        accept:
                                          "image/png, image/gif, image/jpeg, application/pdf"
                                      },
                                      on: { change: _vm.onFilePicked }
                                    })
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row text-start mt-2" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-light",
                                        attrs: { role: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.resetForm()
                                          }
                                        }
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.helper.t("Cancel / Change")
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.deal_price > 0 &&
                                    _vm.contract_multiplier > 0 &&
                                    _vm.starting_at &&
                                    (_vm.reason == "Outside" ||
                                      _vm.reason == "Inside")
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: { role: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.rentProperty()
                                              }
                                            }
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.helper.t(
                                                    "Save and Unpublish"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-454670d2_0", { source: "\n.modal-content{\n    overflow: visible !important;\n}\n.modal-body{\n    overflow: unset !important;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/modal/unpublish-modal.vue"],"names":[],"mappings":";AAulBA;IACA,4BAAA;AACA;AACA;IACA,0BAAA;AACA","file":"unpublish-modal.vue","sourcesContent":["<template>\r\n    <div class=\"modal fade filter-popup-area\" id=\"unpublishModal\" data-bs-backdrop=\"static\" data-bs-keyboard=\"false\"\r\n        tabindex=\"-1\" aria-labelledby=\"staticBackdropLabel\" aria-hidden=\"true\">\r\n        <div class=\"modal-dialog modal-dialog-centered modal-dialog-scrollable\">\r\n            <div v-if=\"property == null\" class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <h5 class=\"modal-title\" id=\"staticBackdropLabel\">{{ helper.t(\"Loading... Please wait.\") }}</h5>\r\n                    <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n                </div>\r\n            </div>\r\n            <div v-if=\"property != null\" class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <h5 class=\"modal-title\" id=\"staticBackdropLabel\"> <img class=\"icon\" :src=\"property_type_icon\">\r\n                        {{ helper.t(\"Unpublish\") }}</h5>\r\n                    <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n                </div>\r\n                <div v-if=\"property.ad_type == 'Sale'\" class=\"modal-body\">\r\n                    <div v-if=\"step == 0\">\r\n                        <div v-if=\"property.floors.length > 0\">\r\n                            <div class=\"row\">\r\n                                <h5>{{ helper.t(\"Select sub property\") }}</h5>\r\n                                <div class=\"col-6\">\r\n                                    <div class=\"form-group\">\r\n                                        <select class=\"form-select form-control border-radius\" aria-label=\"Default select example\"\r\n                                            v-model=\"floor_index\" :disabled=\"main_building\">\r\n                                            <option value=\"\" disabled>{{ helper.t(\"Select Floor\") }}</option>\r\n                                            <option v-for=\"floor in property.floors\" :value=\"floor.floor_num\">\r\n                                                {{ floor.floor_num == 0 ? \"Ground Floor\" : \"Floor \" + floor.floor_num }}</option>\r\n                                        </select>\r\n                                    </div>\r\n                                </div>\r\n                                <div v-if=\"floor_index !== ''\" class=\"col-6\">\r\n                                    <div class=\"form-check\">\r\n                                        <select class=\"form-select form-control border-radius\" aria-label=\"Default select example\"\r\n                                            v-model=\"selected_child\" :disabled=\"main_building\">\r\n                                            <option value=\"\" disabled>{{ helper.t(\"Select Sub Property\") }}</option>\r\n                                            <option v-for=\"child in property.floors[floor_index].children\" :value=\"child\" :disabled=\"child.locked == 1\">\r\n                                                <template v-if=\"child.locked\">\r\n                                                    <b>SOLD</b> {{ child.title }}\r\n                                                </template>\r\n                                                <template v-else>\r\n                                                    {{ child.title }}\r\n                                                </template>\r\n                                            </option>\r\n                                        </select>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row my-3\" v-if=\"property.floors.length > 0\">\r\n                            <div class=\"col-12\">\r\n                                <div class=\"form-check\" @click.prevent=\"main_building=!main_building\">\r\n                                    <input class=\"form-check-input\" type=\"checkbox\" id=\"flexCheckDefault\" :checked=\"main_building\">\r\n                                    <label class=\"form-check-label\">\r\n                                        {{ helper.t(\"Unpublish The Main Building\") }}\r\n                                    </label>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div v-if=\"main_building || property.floors.length == 0 || selected_child != null\">\r\n                            <div v-if=\"!main_building || property.floors.length == 0\" class=\"row pt-2\">\r\n                                <h5>{{ helper.t(\"Did you SOLD through Maalek.net?\") }}</h5>\r\n                                <div class=\"col-12\">\r\n                                    <ul class=\"list-group list-group-flush\">\r\n                                        <li class=\"list-group-item show-hand\" @click=\"reason='Inside'\">\r\n                                            <i v-if=\"reason == 'Inside'\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                            {{helper.t(\"Sold through Maalek.net (Ad will be permanently locked)\")}}\r\n                                        </li>\r\n                                        <li class=\"list-group-item show-hand\" @click=\"reason='Outside'\">\r\n                                            <i v-if=\"reason == 'Outside'\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                            {{helper.t(\"Sold through other source (Ad will be permanently locked)\")}}\r\n                                        </li>\r\n                                        <li v-if=\"property.floors.length == 0\" class=\"list-group-item show-hand\" @click=\"reason='Unpublish'\">\r\n                                            <i v-if=\"reason == 'Unpublish'\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                            {{helper.t(\"Unpublish Only (Ad can be republished later)\")}}\r\n                                        </li>\r\n                                        <li v-if=\"property.floors.length == 0\" class=\"list-group-item show-hand mb-3\" @click=\"reason='Lock'\">\r\n                                            <i v-if=\"reason == 'Lock'\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                            {{helper.t(\"Close this advertisement (Ad will be permanently locked)\")}}\r\n                                        </li>\r\n                                    </ul>\r\n                                    <small v-if=\"reason!='Unpublish' && reason!=''\" class=\"text-danger ms-4\">{{ helper.t(\"Note: Locked ads cannot be republished or edited\") }}</small>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div v-if=\"main_building || reason != ''\" class=\"d-flex justify-content-end mt-2\">\r\n                                <a v-if=\"(property.floors.length == 0 || !main_building) && (reason=='Inside' || reason=='Outside')\" class=\"btn btn-primary\"\r\n                                    @click=\"deal_rent_type = property.floors.length == 0?property.rent_type:selected_child.rent_type;\r\n                                    deal_price = property.floors.length == 0?property.total_price:selected_child.total_price;\r\n                                    step = 1;\">\r\n                                    <p>{{ helper.t(\"Next Step\") }}</p>\r\n                                </a>\r\n                                <a v-else-if=\"(main_building && property.floors.length > 0) || reason != ''\" class=\"btn btn-primary\" @click=\"reason=='Lock'?askLockProperty() : unpublish()\">\r\n                                    <p>{{ helper.t(\"Unpublish\") }}</p>\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"step == 1\">\r\n                        <div class=\"row\">\r\n                            <h5>{{ helper.t(\"Give further information\") }}</h5>\r\n                            <div class=\"col-12\">\r\n                                <div class=\"form-group\">\r\n                                    <label>{{ helper.t(\"Sold for how much?\") }}</label>\r\n                                    <input v-model=\"deal_price\" type=\"number\" class=\"form-control border-radius\">\r\n                                </div>\r\n                                <div class=\"form-group\">\r\n                                    <label>{{ helper.t(\"Buyer's Mobile No. (optional)\") }}</label>\r\n                                    <input v-model=\"tanent\" type=\"text\" class=\"form-control border-radius\">\r\n                                </div>\r\n                                <div class=\"form-group\">\r\n                                    <label>{{ helper.t(\"Buyer's Full Name (optional)\") }}</label>\r\n                                    <input v-model=\"full_name\" type=\"text\" class=\"form-control border-radius\">\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row text-start mt-2\">\r\n                            <div class=\"col-12\">\r\n                                <div class=\"d-flex justify-content-between\">\r\n                                    <a class=\"btn btn-light\" @click=\"resetForm()\">\r\n                                        <p v-if=\"full_name == null\">{{ helper.t(\"Cancel\") }}</p>\r\n                                        <p v-else>{{ helper.t(\"Cancel / Change\") }}</p>\r\n                                    </a>\r\n                                    <a v-if=\"deal_price > 0 && ( reason == 'Outside' || reason == 'Inside' )\" class=\"btn btn-primary\" @click=\"sellProperty()\">\r\n                                        <p>{{ helper.t(\"Save and Unpublish\") }}</p>\r\n                                    </a>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div v-if=\"property.ad_type == 'Rent'\" class=\"modal-body\">\r\n                    <div v-if=\"step == 0\">\r\n                        <div v-if=\"property.floors.length > 0\">\r\n                            <div class=\"row\">\r\n                                <h5>{{ helper.t(\"Select sub property\") }}</h5>\r\n                                <div class=\"col-6\">\r\n                                    <div class=\"form-group\">\r\n                                        <select class=\"form-select form-control border-radius\" :disabled=\"main_building\" aria-label=\"Default select example\"\r\n                                            v-model=\"floor_index\">\r\n                                            <option value=\"\" disabled>{{ helper.t(\"Select Floor\") }}</option>\r\n                                            <option v-for=\"floor in property.floors\" :value=\"floor.floor_num\">\r\n                                                {{ floor.floor_num == 0 ? \"Ground Floor\" : \"Floor \" + floor.floor_num }}</option>\r\n                                        </select>\r\n                                    </div>\r\n                                </div>\r\n                                <div v-if=\"floor_index !== ''\" class=\"col-6\">\r\n                                    <div class=\"form-check\">\r\n                                        <select class=\"form-select form-control border-radius\" :disabled=\"main_building\" aria-label=\"Default select example\"\r\n                                            v-model=\"selected_child\">\r\n                                            <option value=\"\" disabled>{{ helper.t(\"Select Sub Property\") }}</option>\r\n                                            <option v-for=\"child in property.floors[floor_index].children\" :value=\"child\" :disabled=\"child.locked == 1\">\r\n                                                <template v-if=\"child.occupent\">\r\n                                                    {{ child.title }}<b>{{ child.occupent }}</b>\r\n                                                </template>\r\n                                                <template v-if=\"child.locked\">\r\n                                                    <b>{{ helper.t(\"Locked\") }}</b> - {{ child.title }}\r\n                                                </template>\r\n                                                <template v-else>\r\n                                                    {{ child.title }}\r\n                                                </template>\r\n                                            </option>\r\n                                        </select>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row my-3\" v-if=\"property.floors.length > 0\">\r\n                            <div class=\"col-12\">\r\n                                <div class=\"form-check\" @click.prevent=\"main_building=!main_building\">\r\n                                    <input class=\"form-check-input\" type=\"checkbox\" id=\"flexCheckDefault\" :checked=\"main_building\">\r\n                                    <label class=\"form-check-label\">\r\n                                        {{ helper.t(\"Unpublish The Main Building\") }}\r\n                                    </label>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div v-if=\"main_building || property.floors.length == 0 || selected_child != null\">\r\n                            <div v-if=\"!main_building || property.floors.length == 0\" class=\"row pt-2\">\r\n                                <h5>{{ helper.t(\"Did you rented through Maalek.net?\") }}</h5>\r\n                                <div class=\"col-12\">\r\n                                    <ul class=\"list-group list-group-flush\">\r\n                                        <li class=\"list-group-item show-hand\" @click=\"reason='Inside'\">\r\n                                            <i v-if=\"reason == 'Inside'\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                            {{helper.t(\"Yes rented using Maalek.net (unpublish & lock)\")}}\r\n                                        </li>\r\n                                        <li class=\"list-group-item show-hand\" @click=\"reason='Outside'\">\r\n                                            <i v-if=\"reason == 'Outside'\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                            {{helper.t(\"Yes rented, but not using Maalek.net (unpublish & lock)\")}}\r\n                                        </li>\r\n                                        <li v-if=\"property.floors.length == 0\" class=\"list-group-item show-hand\" @click=\"reason='Unpublish'\">\r\n                                            <i v-if=\"reason == 'Unpublish'\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                            {{helper.t(\"Not rented yet. (unpublish)\")}}\r\n                                        </li>\r\n                                        <li v-if=\"property.floors.length == 0\" class=\"list-group-item show-hand\" @click=\"reason='Lock'\">\r\n                                            <i v-if=\"reason == 'Lock'\" class=\"ri-checkbox-circle-fill\"></i>\r\n                                            <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                                            {{helper.t(\"Not for rent now (unpublish & lock)\")}}\r\n                                        </li>\r\n                                    </ul>\r\n                                </div>\r\n                            </div>\r\n                            <div v-if=\"main_building || reason != ''\" class=\"d-flex justify-content-end mt-2\">\r\n                                <a v-if=\"(property.floors.length == 0 || !main_building) && (reason=='Inside' || reason=='Outside')\" class=\"btn btn-primary\"\r\n                                    @click=\"deal_rent_type = property.floors.length == 0?property.rent_type:selected_child.rent_type;\r\n                                    deal_price = property.floors.length == 0?property.total_price:selected_child.total_price;\r\n                                    step = 1;\">\r\n                                    <p>{{ helper.t(\"Next Step\") }}</p>\r\n                                </a>\r\n                                <a v-else-if=\"(main_building && property.floors.length > 0) || reason != ''\" class=\"btn btn-primary\" @click=\"reason=='Lock'?askLockProperty() : unpublish()\">\r\n                                    <p>{{ helper.t(\"Unpublish\") }}</p>\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"step == 1\">\r\n                        <div class=\"row\">\r\n                            <h5>{{ helper.t(\"Give further information\") }}</h5>\r\n                            <div class=\"col-4\">\r\n                                <div class=\"form-group\">\r\n                                    <label>{{ helper.t(\"Yearly Rent\") }}</label>\r\n                                    <input v-model=\"deal_price\" type=\"number\" class=\"form-control border-radius\">\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"col-4\">\r\n                                <div class=\"form-group\">\r\n                                    <label>{{helper.t(\"Starting At\")}}</label>\r\n                                    <Datepicker \r\n                                        dir=\"ltr\"\r\n                                        input-class=\"form-control border-radius text-start\"\r\n                                        v-model=\"starting_at\"\r\n                                        @selected=\"calculate_ending_at\"\r\n                                    ></Datepicker>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"col-4\">\r\n                                <div class=\"form-group\">\r\n                                    <label>{{helper.t(\"Contract Multiplier\")}}</label>\r\n                                    <input\r\n                                        v-model=\"contract_multiplier\"\r\n                                        @change=\"calculate_ending_at\"\r\n                                        type=\"number\"\r\n                                        class=\"form-control border-radius\">\r\n                                    <small v-if=\"ending_at != null\">{{ helper.t(\"Contract Ending At:\") }} <span dir=\"ltr\">{{ ending_at.getDate() + \"-\" + global.global_params.months[ending_at.getMonth()] + \"-\" + ending_at.getFullYear() }}</span></small>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"col-6\">\r\n                                <div class=\"form-group\">\r\n                                    <label>{{ helper.t(\"Renter's Mobile No. (optional)\") }}</label>\r\n                                    <input v-model=\"tanent\" type=\"text\" class=\"form-control border-radius\">\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"col-6\">\r\n                                <div class=\"form-group\">\r\n                                    <label>{{ helper.t(\"Renter's Full Name (optional)\") }}</label>\r\n                                    <input v-model=\"full_name\" type=\"text\" class=\"form-control border-radius\">\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"col-12\">\r\n                                <div class=\"form-group text-center\">\r\n                                    <a class=\"btn border-btn mt-2\" @click=\"onPickFile\">\r\n                                        <p v-if=\"attachment == null\">{{ helper.t(\"Contract File (Optional)\") }}</p>\r\n                                        <p v-else>{{ helper.t(\"Contract File: {0}\",[attachment[\"file\"].substring(0,24) + \"...\" + attachment[\"file\"].substring(attachment[\"file\"].length-4)]) }}</p>\r\n                                    </a>\r\n                                    <input\r\n                                        type=\"file\"\r\n                                        style=\"display: none\"\r\n                                        ref=\"fileInput\"\r\n                                        accept=\"image/png, image/gif, image/jpeg, application/pdf\"\r\n                                        @change=\"onFilePicked\"/>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row text-start mt-2\">\r\n                            <div class=\"col-12\">\r\n                                <div class=\"d-flex justify-content-between\">\r\n                                    <a class=\"btn btn-light\"\r\n                                        role=\"button\"\r\n                                        @click=\"resetForm()\">\r\n                                        <p>{{ helper.t(\"Cancel / Change\") }}</p>\r\n                                    </a>\r\n                                    <a v-if=\"(deal_price > 0 && contract_multiplier > 0 && starting_at) \r\n                                        && (reason == 'Outside' || reason == 'Inside')\"\r\n                                        class=\"btn btn-primary\"\r\n                                        role=\"button\"\r\n                                        @click=\"rentProperty()\">\r\n                                        <p>{{ helper.t(\"Save and Unpublish\") }}</p>\r\n                                    </a>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\nimport * as global from \"../../js/global\" ;\r\nimport * as helper from \"../../js/helper\";\r\nimport full_loading from \"../components/full-loading.vue\";\r\nimport VueSelect from '../../js/vue-select.js';\r\nimport Datepicker from '../../js/vuejs-datepicker.min.js';\r\nexport default {\r\n    components: {\r\n        full_loading: full_loading,\r\n        vue_select: VueSelect,\r\n        Datepicker: Datepicker,\r\n    },\r\n    name: 'unpublish_modal',\r\n    props: {\r\n    },\r\n    data() {\r\n        return {\r\n            global,\r\n            helper,\r\n            is_loading: false,\r\n            error: false,\r\n            exceptions: [],\r\n            property: null,\r\n            main_building: false,\r\n            floor_index: \"\",\r\n            selected_child:null,\r\n            property_name:\"\",\r\n            ad_type_color: '#0000ff',\r\n            property_type_icon: '#0000ff',\r\n            tanent: \"\",\r\n            full_name: null,\r\n            deal_price: null,\r\n            deal_rent_type: \"Annually\",\r\n            step: 0,\r\n            reason:\"\",\r\n            starting_at:new Date(),\r\n            contract_multiplier:1,\r\n            ending_at:null,\r\n            disabled_dates:{\r\n                to: new Date(new Date().setDate(new Date().getDate()-1)),\r\n            },\r\n            attachment:null,\r\n            imageUrl:null,\r\n            filename:null,\r\n            filetype:null,\r\n        }\r\n    },\r\n    mounted() {\r\n        var exampleModal = document.getElementById('unpublishModal');\r\n        exampleModal.addEventListener('show.bs.modal', this.load_property_data);\r\n        this.calculate_ending_at();\r\n    },\r\n    methods: {\r\n        resetForm: function () {\r\n            // this.main_building = true;\r\n            this.floor_index = \"\";\r\n            this.tanent = \"\"; \r\n            this.full_name = null;\r\n            this.attachment = null;\r\n            this.step = 0;\r\n            this.reason = \"\";\r\n            this.selected_child = null;\r\n            this.resetErrors();\r\n        },\r\n        resetErrors: function () {\r\n            this.error = false;\r\n            this.exceptions = [];\r\n        },\r\n        load_property_data: async function (event) {\r\n            this.loading = true;\r\n            this.property = null;\r\n            this.resetForm();\r\n            this.main_building = false;\r\n            // Button that triggered the modal\r\n            var button = event.relatedTarget;\r\n            // Extract info from data-bs-* attributes\r\n            this.property_name = button.getAttribute('data-bs-property-name');\r\n            this.form_sent = true;\r\n            let params = {\r\n                property_name: this.property_name\r\n            };\r\n            try {\r\n                let res = await $.ajax({\r\n                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                    url: \"/api/method/maalek.api.get_property_with_children\",\r\n                    type: \"GET\",\r\n                    data: params //for GET request\r\n                    // data: JSON.stringify(params) //for POST request\r\n                });\r\n                this.property = res.message;\r\n                // if (this.property.floors.length > 0)\r\n                //     this.main_building = false;\r\n                this.loading = false\r\n                this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];\r\n                this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];\r\n                if(this.property.floors.length > 0){\r\n                    this.main_building = false;\r\n                }else{\r\n                    this.main_building = true;\r\n                }\r\n                this.$forceUpdate();\r\n            } catch (e) {\r\n                console.log(\"failed\");\r\n                console.log(e);\r\n                this.exceptions = helper.showException(e);\r\n            }\r\n\r\n            this.loading = false\r\n        },\r\n        getFullname: async function () {\r\n            this.resetErrors();\r\n            this.full_name = null;\r\n            let params = {\r\n                user: this.tanent\r\n            };\r\n            try {\r\n                let res = await $.ajax({\r\n                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                    url: \"/api/method/maalek.api.get_fullname\",\r\n                    type: \"GET\",\r\n                    data: params //for GET request\r\n                    // data: JSON.stringify(params) //for POST request\r\n                });\r\n                this.loading = false;\r\n                this.full_name = res.message;\r\n                this.$forceUpdate();\r\n            } catch (e) {\r\n                console.log(e);\r\n                this.error = true;\r\n                this.exceptions = helper.showException(e);\r\n            }\r\n            this.loading = false;\r\n        },\r\n        askLockProperty(){\r\n            if(this.loading || !frappe.session_user || frappe.session_user == \"Guest\")\r\n                return;\r\n            bootbox.confirm({\r\n                message: `<div class=\"alert alert-danger\" role=\"alert\">\r\n                        <b>`+helper.t(\"Warning: you cannot undo this action.\")+`</b><br>\r\n                        `+helper.t(\"Do you want to lock this property permanently?\")+`\r\n                </div>`,\r\n                buttons: {\r\n                    confirm: {\r\n                        label: helper.t(\"Yes\"),\r\n                        className: 'btn-success'\r\n                    },\r\n                    cancel: {\r\n                        label: helper.t(\"No\"),\r\n                        className: 'btn-danger'\r\n                    }\r\n                },\r\n                backdrop: true,\r\n                callback: (results) => results?this.unpublish():console.log(\"cancel\"),\r\n            });\r\n        },\r\n        unpublish: async function (){\r\n            this.resetErrors();\r\n            this.form_sent = true;\r\n            let params = {\r\n                property_name: this.property.name,\r\n                reason: this.reason\r\n            };\r\n            global.emitter.emit(\"show-full-loading\");\r\n            try {\r\n                let res = await $.ajax({\r\n                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                    url: \"/api/method/maalek.api.unpublish\",\r\n                    type: \"POST\",\r\n                    // data: params //for GET request\r\n                    data: JSON.stringify(params) //for POST request\r\n                });\r\n                this.loading = false\r\n                global.emitter.emit(\"refresh-tanent\");\r\n                helper.showSuccess(this.reason==\"Lock\"?\"Property locked permanenetly\":\"Property unpublished\",()=>{\r\n                    location.reload();\r\n                });\r\n            } catch (e) {\r\n                this.error = true;\r\n                this.exceptions = helper.showException(e);\r\n            }\r\n            global.emitter.emit(\"hide-full-loading\");\r\n            this.loading = false\r\n        },\r\n        sellProperty: async function (){\r\n            this.resetErrors();\r\n            this.form_sent = true;\r\n            let params = {\r\n                property_name: this.main_building ? this.property.name : this.selected_child.name,\r\n                reason: this.reason,\r\n                tanent: this.tanent,\r\n                tanent_full_name: this.full_name,\r\n                deal_price: this.deal_price,\r\n            };\r\n            try {\r\n                let res = await $.ajax({\r\n                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                    url: \"/api/method/maalek.api.sell_property\",\r\n                    type: \"POST\",\r\n                    // data: params //for GET request\r\n                    data: JSON.stringify(params) //for POST request\r\n                });\r\n                this.loading = false\r\n                this.error = false;\r\n                global.emitter.emit(\"refresh-tanent\");\r\n                helper.showSuccess(\"Property sold\",()=>{\r\n                    location.reload();\r\n                });\r\n            } catch (e) {\r\n                this.error = true;\r\n                this.exceptions = helper.showException(e);\r\n            }\r\n            this.loading = false\r\n        },\r\n        rentProperty: async function (){\r\n            this.resetErrors();\r\n            this.form_sent = true;\r\n            let params = {\r\n                property_name: this.main_building ? this.property.name : this.selected_child.name,\r\n                reason: this.reason,\r\n                deal_price: this.deal_price,\r\n                deal_rent_type: this.deal_rent_type,\r\n                tanent: this.tanent,\r\n                tanent_full_name: this.full_name,\r\n                starting_at:this.starting_at,\r\n                ending_at:this.ending_at,\r\n                attachment:this.attachment\r\n            };\r\n            try {\r\n                let res = await $.ajax({\r\n                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                    url: \"/api/method/maalek.api.rent_property\",\r\n                    type: \"POST\",\r\n                    // data: params //for GET request\r\n                    data: JSON.stringify(params) //for POST request\r\n                });\r\n                this.loading = false\r\n                this.error = false;\r\n                global.emitter.emit(\"refresh-tanent\");\r\n                helper.showSuccess(\"Property rented\",()=>{\r\n                    location.reload();\r\n                });\r\n            } catch (e) {\r\n                this.error = true;\r\n                this.exceptions = helper.showException(e);\r\n            }\r\n            this.loading = false\r\n        },\r\n        calculate_ending_at: async function (val) {\r\n            var temp_date = new Date(this.starting_at);\r\n            if(val != undefined && val instanceof Date)\r\n                temp_date = new Date(val);\r\n            if(this.deal_rent_type == \"Monthly\"){\r\n                this.ending_at =  new Date(temp_date.setMonth(temp_date.getMonth() + parseInt(this.contract_multiplier)));\r\n            }else if(this.deal_rent_type == \"Half Yearly\"){\r\n                this.ending_at =  new Date(temp_date.setMonth(temp_date.getMonth() + (6 * parseInt(this.contract_multiplier))));\r\n            }else{\r\n                this.ending_at =  new Date(temp_date.setFullYear(temp_date.getFullYear() + parseInt(this.contract_multiplier)));\r\n            }\r\n        },\r\n        onPickFile () {\r\n            this.$refs.fileInput.click()\r\n        },\r\n        onFilePicked (event) {\r\n            const files = event.target.files\r\n            if (files && files[0]) {\r\n                this.attachment = {};\r\n                this.attachment[\"file\"] = files[0].name\r\n                this.attachment[\"type\"] = files[0].type\r\n                const fileReader = new FileReader()\r\n                fileReader.readAsDataURL(files[0])\r\n                let reader = new FileReader;\r\n                reader.onload = e => {\r\n                    this.attachment[\"data\"] = e.target.result;\r\n                }\r\n                reader.readAsDataURL(files[0]);\r\n                this.$forceUpdate();\r\n            }\r\n        }\r\n    },\r\n    computed: {\r\n        calculate_rent(){\r\n            if(this.deal_rent_type == \"Monthly\"){\r\n                return this.deal_price * 12;\r\n            }else if(this.deal_rent_type == \"Half Yearly\"){\r\n                return this.deal_price * 2;\r\n            }else{\r\n                return this.deal_price;\r\n            }\r\n        }\r\n    }\r\n}\r\n</script>\r\n\r\n<style>\r\n    .modal-content{\r\n        overflow: visible !important;\r\n    }\r\n    .modal-body{\r\n        overflow: unset !important;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/unpublish-modal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__